import types from '../types';
import { getURLValueFromActiveInputs } from '.';

/**
 * @param {types.Filter[] || types.AdvancedFilter[]} filters
 * @returns {Object}
 */
const getRequestBodyFromFilters = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return {};
    }

    return filters.reduce((acc, curr) => {
        if (curr.type === 'checkbox') {
            return {
                ...acc,
                [curr.id]: getURLValueFromActiveInputs(curr.options, curr.radio)
            };
        }

        return {
            ...acc,
            [curr.id]: curr.value
        };
    }, {});
};

export default getRequestBodyFromFilters;
